<template>
  <ul class="header">
    <li
      v-for="(item, id) in data"
      :key="id"
      :class="{ active: index == item }"
      @click="$emit('click', item)"
    >
      <span><i class="el-icon-caret-right"></i></span>{{ item }}
    </li>
  </ul>
</template>
<script>
export default {
  name: "wx-bread",
  props: {
    data: {
      type: Array,
      default: () => [
        "综合规划专业",
        "交通设计专业",
        "城建设计专业",
        "工程管理",
        "工程技术研究",
      ],
    },
    index: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      // data: ["公司新闻", "集团新闻", "行业动态"],
    };
  },
  components: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang='less'>
.header {
  width: 100%;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  li {
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    span {
      color: @co;
      margin-right: 2px;
    }
  }
}
.active {
  color: @co;
}
@media (max-width: 1000px) {
  .header {
    height: 40px;
    justify-content: space-around;
    li {
      padding: 0 1px;
      font-size: 12px;
      transform: scale(0.9);
      white-space: nowrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bread/wx_header.vue